import { Component } from '@angular/core';
import { MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';
import { ErrorSnackbarDataCy } from './error-snackbar.types';

/**
 *
 * A custom variation of the MatSnackBar class
 * All properties are required to make it function
 *
 * @export
 * @class ErrorSnackbarComponent
 */
@Component({
    selector: 'error-snackbar',
    templateUrl: './error-snackbar.component.html',
    styleUrls: ['./error-snackbar.component.scss']
})
export class ErrorSnackbarComponent {
    message: string;
    action: string;
    /**
    * @type {MatSnackBarRef<ErrorSnackbarComponent>}
    * @memberOf ErrorSnackbarComponent
    */
    snackBarRef: MatSnackBarRef<ErrorSnackbarComponent>;

    protected errorSnackbarDataCy = ErrorSnackbarDataCy;

    get hasAction(): boolean {
        return !!this.action;
    }

    dismiss(): void {
        this.snackBarRef.dismissWithAction();
    }
}
